/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolWaterDamageIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-water-damage"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6.85 20.8Q5.72 20.8 4.96 20.04Q4.2 19.27 4.2 18.15L4.2 11.55L2.83 12.65Q2.4 13 1.86 12.91Q1.32 12.82 0.97 12.4Q0.65 11.97 0.72 11.45Q0.8 10.93 1.23 10.57L10.38 3.48Q11.1 2.9 12 2.9Q12.9 2.9 13.63 3.48L22.77 10.57Q23.2 10.93 23.27 11.45Q23.35 11.97 23 12.4Q22.65 12.82 22.11 12.91Q21.57 13 21.15 12.65L19.8 11.57L19.8 18.15Q19.8 19.27 19.04 20.04Q18.27 20.8 17.15 20.8ZM12 16.32Q12 16.32 12.47 16.32Q12.95 16.32 13.64 15.64Q14.32 14.95 14.32 14Q14.32 13.28 13.85 12.35Q13.38 11.43 12 9.43Q10.63 11.43 10.15 12.35Q9.68 13.28 9.68 14Q9.68 14.95 10.36 15.64Q11.05 16.32 12 16.32Z" fill={color} />
    </svg>
  );
}
